module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-600px-80bd26e5c90511a1d825ef9a3d3f743b.jpg";